import React from "react";

const ProgressBar = ({
  min,
  max,
  current,
  percentage,
  label = "",
  barWrapper = false,
}) => {
  return (
    <div class="w-100 progress category-bar">
      {barWrapper ? (
        <div className="bar-wrapper">
          <div
            class="progress-bar"
            style={{
              width: `${percentage}%`,
            }}
            role="progressbar"
            aria-valuenow={current}
            aria-valuemin={min}
            aria-valuemax={max}
          ></div>
        </div>
      ) : (
        <div
          class="progress-bar"
          style={{
            width: `${percentage}%`,
          }}
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={min}
          aria-valuemax={max}
        ></div>
      )}
      <span>{label && label}</span>
    </div>
  );
};

export default ProgressBar;
